module.exports = __webpack_public_path__ + "static/media/firstScreenBg.cdce817b.svg";